'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$RecipeListAppPage$() {
}
export { $c_Lmealorama_AppRouter$RecipeListAppPage$ as $c_Lmealorama_AppRouter$RecipeListAppPage$ };
$p = $c_Lmealorama_AppRouter$RecipeListAppPage$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$RecipeListAppPage$;
/** @constructor */
function $h_Lmealorama_AppRouter$RecipeListAppPage$() {
}
export { $h_Lmealorama_AppRouter$RecipeListAppPage$ as $h_Lmealorama_AppRouter$RecipeListAppPage$ };
$h_Lmealorama_AppRouter$RecipeListAppPage$.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-505471164);
});
$p.m = (function() {
  return "RecipeListAppPage";
});
$p.q = (function() {
  return 0;
});
$p.r = (function() {
  return "RecipeListAppPage";
});
$p.g = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
var $d_Lmealorama_AppRouter$RecipeListAppPage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$RecipeListAppPage$, "mealorama.AppRouter$RecipeListAppPage$", ({
  Fx: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_AppRouter$RecipeListAppPage$ as $d_Lmealorama_AppRouter$RecipeListAppPage$ };
var $n_Lmealorama_AppRouter$RecipeListAppPage$;
function $m_Lmealorama_AppRouter$RecipeListAppPage$() {
  if ((!$n_Lmealorama_AppRouter$RecipeListAppPage$)) {
    $n_Lmealorama_AppRouter$RecipeListAppPage$ = new $c_Lmealorama_AppRouter$RecipeListAppPage$();
  }
  return $n_Lmealorama_AppRouter$RecipeListAppPage$;
}
export { $m_Lmealorama_AppRouter$RecipeListAppPage$ as $m_Lmealorama_AppRouter$RecipeListAppPage$ };
//# sourceMappingURL=mealorama.-App-Router$-Recipe-List-App-Page$.js.map
